import { styled } from '../../../Utilities';
import { getStyles } from './PlainCard.styles';
import { PlainCardBase } from './PlainCard.base';
export var PlainCard = styled(PlainCardBase, getStyles, undefined, {
    scope: 'PlainCard'
});
//# sourceMappingURL=PlainCard.js.map